import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	tabsPaper: {
		borderBottom: 'none',
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0
	},
	tabsIndicator: {
		backgroundColor: theme.palette.primary.main
	},
	tabRoot: {
		maxWidth: 180,
		marginRight: theme.spacing(2),
		'&:hover': {
			color: theme.palette.secondary.main,
			opacity: 1
		},
		'&$tabSelected': {
			color: theme.palette.secondary.main
		},
		'&:focus': {
			color: theme.palette.secondary.main
		}
	},
	tabSelected: {},
	tabsSkeletonContainer: {
		width: `calc(100% - ${theme.spacing(6)}px)`,
		maxWidth: 480,
		padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
		overflowX: 'hidden'
	}
}));
